var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 14H1.625C1.003 14 .5 13.476.5 12.83V1.892l5.174 4.969-4.258 6.044 5.74-4.62 1.66 1.595c.334.26.687.22.674.22.297.002.584-.156.702-.232l-.018.017c.027-.021.04-.032.053-.04l-.035.023 1.741-1.677 5.666 4.707-4.335-5.989L18.5 1.867v10.962c0 .647-.503 1.171-1.125 1.171zM.5 1.11C.5.496 1.003 0 1.625 0h15.75c.622 0 1.125.496 1.125 1.11L9.495 7.467.5 1.11z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgEmailIcon;